import { createContext } from "react";
import useLocalStorageState from "../hooks/useLocalStorageState";

export const BatchMarketPlaceContext = createContext();

const BatchProvider = ({ children }) => {
  const [batch_skipPages, batch_setSkipPages] = useLocalStorageState(
    "batch_skipPages",
    ""
  );
  const [batch_selectedMarketPlaces, batch_setSelectedMarketPlaces] =
    useLocalStorageState("batch_selectedMarketPlaces", []);
  const [batch_selectedCategoryId, batch_setSelectedCategoryId] =
    useLocalStorageState("batch_selectedCategoryId", "");
  const [batch_selectedCategoryName, batch_setSelectedCategoryName] =
    useLocalStorageState("batch_selectedCategoryName", "");
  const [batch_selectedSubCategoryId, batch_setSelectedSubCategoryId] =
    useLocalStorageState("batch_selectedSubCategoryId", "");
  const [batch_selectedSubCategoryName, batch_setSelectedSubCategoryName] =
    useLocalStorageState("batch_selectedSubCategoryName", "");
  const [batch_selectedAddOnServices, batch_setSelectedAddOnServices] =
    useLocalStorageState("batch_selectedAddOnService", []);
  const [batch_selectedMarketPlaceId, batch_setSelectedMarketPlaceId] =
    useLocalStorageState("batch_selectedMarketPlaceId", []);
  const [batch_selectedMarketPlaceName, batch_setSelectedMarketPlaceName] =
    useLocalStorageState("batch_selectedMarketPlaceName", []);
  return (
    <BatchMarketPlaceContext.Provider
      value={{
        batch_skipPages,
        batch_setSkipPages,
        batch_selectedMarketPlaces,
        batch_setSelectedMarketPlaces,
        batch_selectedCategoryId,
        batch_setSelectedCategoryId,
        batch_selectedCategoryName,
        batch_setSelectedCategoryName,
        batch_selectedSubCategoryId,
        batch_setSelectedSubCategoryId,
        batch_selectedSubCategoryName,
        batch_setSelectedSubCategoryName,
        batch_selectedAddOnServices,
        batch_setSelectedAddOnServices,
        batch_selectedMarketPlaceId,
        batch_setSelectedMarketPlaceId,
        batch_selectedMarketPlaceName,
        batch_setSelectedMarketPlaceName,
      }}
    >
      {children}
    </BatchMarketPlaceContext.Provider>
  );
};

export default BatchProvider;
